import { clsx } from 'clsx';
import { FC, ReactNode } from 'react';

import { ScrollBox } from '../ScrollBox/ScrollBox';

type Props = {
  children: ReactNode;
  variant?: 'default' | 'recently-viewed' | 'car-match';
  carouselName?: string;
};

export const CarouselTrack: FC<Props> = ({ children, variant = 'default', carouselName }) => {
  return (
    <ScrollBox
      className={clsx(
        'carouselTrack flex snap-x snap-mandatory items-stretch gap-4 overflow-y-hidden',
        // Enable Safari touch scrolling physics which is needed for scroll snap
        '[-webkit-overflow-scrolling:touch]',
        // Hide scrollbar on IE and Edge
        '[-ms-overflow-style:none]',
        // Hide scrollbar on Firefox
        '[scrollbar-width:none]',
        // Hide scrollbar on Chrome, Safari and Opera
        '[&::-webkit-scrollbar]:hidden',
        {
          'ml-0! pl-0! md:-ml-7! md:pl-7!': variant === 'recently-viewed',
          'sm:px-8 mdp:-mx-2 mdp:px-2': variant === 'car-match',
        },
      )}
      data-testid={getScrollBoxTestId(carouselName)}
    >
      {children}
    </ScrollBox>
  );
};

const getScrollBoxTestId = (carouselName?: string) => {
  return carouselName ? `${carouselName}-scrollbox` : 'carousel-scrollbox';
};
